import Image from '@base/Image';
import styled from '@emotion/styled';
import { useIsMobile } from '@stores/AppCommonData';
import { mediaQuery, Spacings } from '@styles/index';
import { useRouter } from 'next/router';
import React, { useEffect, useRef } from 'react';
import TestSeriesDetails from './TestSeriesDetails';
import useEnrollInfo from './useEnrollInfo';
import useSkuDetails from './useSkuDetails';
import useTestSeriesInfo from './useTestSeriesInfo';

const HeaderWrapper = styled.div`
  min-height: ${Spacings.SPACING_17B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_4B};
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  ${mediaQuery.uptoMobile} {
    flex-direction: column-reverse;
    justify-content: space-between;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  width: 500px;
  height: 286px;

  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: calc(100vh / 4);
    margin-bottom: ${Spacings.SPACING_4B};
  }
`;
const testSeriesBanner =
  'https://static.uacdn.net/web-cms/testseries_banner_2e649f6842.svg';

const Header = ({ fromStore, setIsStickyHeaderShown }) => {
  const headerRef = useRef();
  const { data } = useTestSeriesInfo();
  const { goal = {}, uid } = data;

  const { uid: goalUid } = goal;

  const { enrolledState } = useEnrollInfo(uid, goalUid, {
    revalidateOnMount: true
  });

  const { isEnrolled } = enrolledState ?? {};

  const { query } = useRouter();
  const { hasSkuAccess } = useSkuDetails(goalUid, query.courseUID);

  const isMobile = useIsMobile();

  useEffect(() => {
    const headerElement = headerRef.current;
    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsStickyHeaderShown(false);
        }
        if (entries[0].intersectionRatio === 0) {
          setIsStickyHeaderShown(true);
        }
      },
      { threshold: 0, rootMargin: '-72px' }
    );
    intersectionObserver.observe(headerElement);
    return () => intersectionObserver.unobserve(headerElement);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <HeaderWrapper ref={headerRef}>
      <Container>
        <TestSeriesDetails
          isSticky={false}
          fromStore={fromStore}
          isHeaderShown
        />

        {(!isMobile || (isMobile && !isEnrolled && !hasSkuAccess)) && (
          <ImageWrapper>
            <Image src={testSeriesBanner} alt="" layout="fill" priority />
          </ImageWrapper>
        )}
      </Container>
    </HeaderWrapper>
  );
};
export default React.memo(Header);
